import { faClose } from '@fortawesome/free-solid-svg-icons/faClose'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useLockScroll } from '@src/hooks/useLockScroll'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { IStore, store } from '@src/store'

import Env from '@src/RelayEnvironment'
import classes from './WalletModal.module.scss'

import './BonusModal.scoped.scss'
import { WalletGamblerTab } from './WalletGamblerTab'
import { WalletConstant } from '@src/reducers/wallet.reducer'
import { commitMutation } from 'relay-runtime'
import { updateUserPreference } from '@src/queries/updateUserPreference'
import { updateUserPreferenceMutation } from '@src/queries/__generated__/updateUserPreferenceMutation.graphql'
import { UserProp } from '@src/stores/auth/user'

import cookies from 'js-cookie'

export const BonusModal = ({ closeCallback, currency }: { closeCallback: () => void; currency?: string }) => {
  const { t } = useTranslation()

  const [popup, setPopup] = useState(null)
  const [isOpened, setIsOpened] = useState(false)

  const wallet = useSelector((store: IStore) => store.wallet)

  const gamblerWallet = wallet.wallets.find((w) => !!w.campaign?.meta?.playable)

  const dispatch = useDispatch()

  const setGamblerBalanceActive = useCallback(() => {
    const activeWallet = store.getState().wallet.activeWallet
    dispatch({ type: WalletConstant.SET_ACTIVE_WALLET, wallet: gamblerWallet })
    commitMutation<updateUserPreferenceMutation>(Env, {
      mutation: updateUserPreference,
      variables: {
        input: {
          key: UserProp.ACTIVE_COIN,
          value: 'virtual_' + gamblerWallet?.virtualId + '_' + gamblerWallet?.currency,
        },
      },
      onCompleted: () => {
        if (!activeWallet) return
        cookies.set('last_non_virtual_wallet_currency', activeWallet.currency, { expires: 365 })
      },
    })
  }, [dispatch, gamblerWallet])

  // if currency is passed set active wallet
  useEffect(() => {
    if (currency) {
      const w = {
        balance: 0,
        currency: currency,
        virtual: false,
        virtualId: 0,
      }

      dispatch({ type: WalletConstant.SET_ACTIVE_WALLET, wallet: w })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency])

  useEffect(() => {
    setIsOpened(true)

    return () => {
      setIsOpened(false)
    }
  }, [])

  useLockScroll(isOpened)

  return (
    <div className={classNames('bonus-modal flex flex-col', classes.root)}>
      <div className="modal-header">
        <div className="flex gap-x-16">
          <button
            className={classNames('title', {
              active: true,
            })}
            onClick={() => {
              if (gamblerWallet) {
                setGamblerBalanceActive()
              }
            }}
          >
            {t('wallet.listView.specialBonus', 'SPECIAL BONUS')}
          </button>
        </div>
        <FontAwesomeIcon className="close-modal" icon={faClose} size="2x" onClick={() => closeCallback()} />
      </div>
      <WalletGamblerTab closeWalletModal={() => closeCallback()} />
      {popup && (
        <div className="popup">
          <div className="relative">
            <FontAwesomeIcon className="close" icon={faClose} size="2x" onClick={() => setPopup(null)} />
            <div className="content">{popup}</div>
          </div>
        </div>
      )}
    </div>
  )
}
